import React, {createContext, useEffect, useReducer, useState} from 'react'

const reducer = (state, action) => {
    switch (action.type) {
        case 'RELOAD_STATE_ATOL_ERR_TEST': {
            return {
                ...state,
                AtolError: action.payload,
            }
        }
        case 'RELOAD_STATE_ATOL_STATUS_MODAL':{
            return {
                ...state,
                AtolModal: action.payload,
            }
        }
        case 'RELOAD_STATE_ATOL_IP_ADD':{
            return {
                ...state,
                AtolIpAdd: action.payload,
            }
        }
        case 'RELOAD_STATE_ATOL_PORT':{
            return {
                ...state,
                AtolPort: action.payload,
            }
        }
        case 'RELOAD_STATE_ATOL_CONNECTION':{
            return {
                ...state,
                AtolConnection: action.payload,
            }
        }
        case 'RELOAD_STATE_ATOL_ERROR_CATCH':{
            return {
                ...state,
                ErrorCatch: action.payload,
            }
        }
        default:
    }
};

const ArrayStateDefault = {
    AtolModal:false,
    AtolConnection:false,
    AtolIpAdd:'127.0.0.1',
    AtolPort:'16732',
    AtolError:'201',
    ErrorCatch:false,
};

const AtolErrorTestContext = createContext(
    {
        ...ArrayStateDefault,
        setAtolError: () => {},
        setAtolModal: () => {},
        setAtolIpAdd: () => {},
        setAtolPort: () => {},
        setAtolConnection: () => {},
        setErrorCatch: () => {}
    }
);

export const AtolErrorTestProvider = ({ settings, children }) => {
    const [state, dispatch] = useReducer(reducer,
            ArrayStateDefault
        );

    const setAtolError = async (status)=>{
        // console.log('что за жопа');
        try{
            // console.log('Сменяем ошибку ккт', status);
            dispatch({
                type: 'RELOAD_STATE_ATOL_ERR_TEST',
                payload: status,
            });
            return status;
        }catch (e) {
            console.log('Ошибка при смене статуса ошибки ккт', e);
        }
    }

    const setAtolModal= async (status)=>{
        // console.log('Отработка смена статуса модалки')
        try{
            // console.log('Меняем статус модалки на',status);
            dispatch({
                type: 'RELOAD_STATE_ATOL_STATUS_MODAL',
                payload: status,
            });
        }catch (e) {
            console.log('Ошибка при смене статуса Модалки', e);
        }

    }
    const setAtolIpAdd= async (status)=>{
        // console.log('Отработка смена ип')
        try{
            // console.log('Меняем ип на',status);
            dispatch({
                type: 'RELOAD_STATE_ATOL_IP_ADD',
                payload: status,
            });
        }catch (e) {
            console.log('Ошибка при смене ип', e);
        }

    }
    const setAtolPort= async (status)=>{
        // console.log('Отработка смена порта')
        try{
            // console.log('Меняем порт на',status);
            dispatch({
                type: 'RELOAD_STATE_ATOL_PORT',
                payload: status,
            });
        }catch (e) {
            console.log('Ошибка при смене порта', e);
        }

    }
    const setAtolConnection= async (status)=>{
        // console.log('Отработка статуса соединения с ккт')
        try{
            // console.log('Меняем статус на',status);
            dispatch({
                type: 'RELOAD_STATE_ATOL_CONNECTION',
                payload: status,
            });
        }catch (e) {
            console.log('Ошибка запросе статуса', e);
        }

    }
    const setErrorCatch= async (status)=>{
        // console.log('Отработка отлова ошибки')
        try{
            // console.log('Отлов ошибки на',status);
            dispatch({
                type: 'RELOAD_STATE_ATOL_ERROR_CATCH',
                payload: status,
            });
        }catch (e) {
            console.log('Ошибка при отлове ошибки', e);
        }

    }

    // const getALlStatusOrderServer = async () => {
    //     // console.log('Все работает, ну должно');
    //     try {
    //         const res = await axios.get('/api/reference/getAllStatusOrder');
    //         dispatch({
    //             type: 'LOAD_STATUS_ORDER',
    //             payload: res.data,
    //         });
    //
    //         return res.data;
    //     } catch (e) {
    //         console.error(e)
    //     }
    // };

    // console.log('КОНСОЛЬ ЛОГ ИЗ ФАЙЛА КОНТЕКСТ - ',state);

    return (
        <AtolErrorTestContext.Provider
            value={{
                ...state,
                setAtolError,
                setAtolModal,
                setAtolIpAdd,
                setAtolPort,
                setAtolConnection,
                setErrorCatch
            }}
        >
            {children}
        </AtolErrorTestContext.Provider>
    )
};

export default AtolErrorTestContext;